import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import db from "../data/Database";
// import MD5 from "md5";
// import days from "../common/Functions/daysFunctons";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    connections: null,
  },
  mutations: {
    SET_USER_DATA(state, userData) {
      state.user = userData;
      // Update the currentState DB
      db.currentState
        .update(1, {
          Contact: userData.contact,
          token: userData.OUG_token,
        })
        .catch((e) => {
          console.error(e + " ocurred updating currentState!");
        });

      // Update the Teams DB Store
      db.Teams.bulkPut(userData.current_teams).catch(db.BulkError, (e) => {
        console.error(e.failures.length + " Teams failed to be added!");
      });

      // Update the Access DB Store
      db.Access.bulkPut(userData.current_access).catch(db.BulkError, (e) => {
        console.error(e.failures.length + " Accesses failed to be added!");
      });

      // Update the ContactDetails DB Store
      db.ContactDetails.bulkPut(userData.contact_details).catch(
        db.BulkError,
        (e) => {
          console.error(
            e.failures.length + " Contact Details failed to be added!"
          );
        }
      );

      // Update the Codes DB Store
      db.Codes.bulkPut(userData.codes).catch(db.BulkError, (e) => {
        console.error(e.failures.length + " Codes failed to be added!");
      });

      // Update the Codes DB Store
      db.Locations.bulkPut(userData.locations).catch(db.BulkError, (e) => {
        console.error(e.failures.length + " Locations failed to be added!");
      });

      // console.log("DB", db)
      // console.log("TEST", db.currentState)
      // if(db.currentState.Contact.Association === db.currentState.Access.Code_id){
      //   console.log("Access ID:", db.Access.Code_id)
      //   console.log("Associations Match")
      // }

      localStorage.setItem("Coach", JSON.stringify(userData));

      axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${userData.OUG_token}`;
    },
    CLEAR_USER_DATA() {
      db.currentState.update(1, {
        Contact: {},
        token: null,
      });
      localStorage.removeItem("Coach");
      // db.contactDetails
      // location.reload();
    },
    SET_USER_CONNECTIONS(state, connectionsData) {
      state.connections = connectionsData;
      db.currentState.update(1, {
        Connections: connectionsData,
      });
      localStorage.setItem("Connections", JSON.stringify(connectionsData));
    },


    UPDATE_USER(state, userData) {
      state.user.contact.Firstname = userData.Payload.Firstname;
      state.user.contact.Surname = userData.Payload.Surname;
      state.user.contact.Gender = userData.Payload.Gender;
      state.user.contact.Date_of_Birth = userData.Payload.Date_of_Birth;
      state.user.contact.Login = userData.Payload.Login;
      state.user.contact.Password = userData.Payload.Password;
      state.user.contact.Email = userData.Payload.Email;
      // Update the currentState DB
      db.currentState
          .update(1, {
              Contact: state.user.contact,
              token: userData.OUG_token,
          })
          .catch((e) => {
              console.error(e + " ocurred updating currentState!");
          });
      localStorage.setItem("Coach", JSON.stringify(state.user));
    },
    // checkExisting(code) {
    //   // lookup Coach local store and return Contact_Details_id if found otherwise 0
    //   let retid = 0
    //   let coach = JSON.parse(localStorage.getItem("Coach")).contact_details
    //   let index = coach.findIndex((ele) => {
    //     return ele.Code == code
    //   })
    //   // In index > 0 found existion record so update local store
    //   if ( index > 0 ) {
    //     retid = coach[index].Contact_Details_id
    //   }
    //   return retid
    // },
  },
  actions: {
    register({ commit }, credentials) {
      return axios
        .post("https://server.ownurgoal.net.au/auth/OUG_Register", credentials)
        .then(({ data }) => {
          commit("SET_USER_DATA", data);
        });
    },
    reset({ commit }, credentials) {
      console.log("credentials", credentials);
      return axios
        .post(
          "https://server.ownurgoal.net.au/auth/OUG_Reset_Credentials",
          credentials
        )
        .then(({ data }) => {
          commit("CLEAR_USER_DATA", data);
        });
    },
    login({ commit }, credentials) {
      return axios
        .post("https://server.ownurgoal.net.au/auth/OUG_login", credentials)
        .then(({ data }) => {
          localStorage.setItem("sLastUser", credentials.username);
          localStorage.setItem("sUserUID", credentials.password);
          commit("SET_USER_DATA", data.data);
        });
    },
    logout({ commit }) {
      commit("CLEAR_USER_DATA");
    },
    getConnections({ commit }, credentials) {
      return axios
        .get(
          `https://server.ownurgoal.net.au/oug_app/OUG_Connections/${credentials}`
        )
        .then(({ data }) => {
          commit("SET_USER_CONNECTIONS", data);
        });
    },
    updateProfile({ commit }, userDataPayload) {
      return axios
        .post("https://server.ownurgoal.net.au/auth/OUG_Update_Profile", userDataPayload)
        .then(({ data }) => {
          commit("UPDATE_USER", data);
        });
    },
  },
  getters: {
    loggedIn(state) {
      return !!state.user;
    },
    currentUser(state) {
      return state.user.contact;
    },
  },
});
